
import {initWebComponent} from "@/helpers/web-component-helper";

export class LayerInfoLegendComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
<div class="info-menu-info-header info-menu-info-draggable">
     <div class="card mb-3 mr-3 bg-lighter pb-2 mt-3" style="border-radius: 0 10px 10px 10px;min-height:460px;max-height: calc(100vh - 114px);overflow: auto;-webkit-overflow-scrolling: touch;">
      <div class="card-header font-weight-bold p-2 ">
         <layout-language data-key="legend"></layout-language>
         <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
            <span class="fa fa-minus"></span>
         </button>
     </div>
        <div id="divInfoMenuInfoEmpty" class="info-menu-info">
            <div class="card-body text-center" style="margin-top:180px">
                <p>
                    Actieveer een laag om de legenda te bekijken
                </p>
            </div>
        </div>
    </div>
</div>
`;

        initWebComponent(this, template)
    }
}

